export const enum ProcessMapNodeCateories {
  Default = 1,
  CustomEmail = 2,
  DecisionGateway = 3
}
